import { IUserProfileResponse, IUserWebAnalyticsResponse } from 'api/components/User/types';

import * as actionTypes from 'store/user/actionTypes';

import { SagaActionsProps } from 'types/commonInterfaces';
import { UserFeature } from 'types/apiInterfaces/user';
import {
    BaseSendEmailRequest,
    IUpdatePersonalisationRequest,
    IUpdateUserRequest,
    IUserPersonalisationData,
    UserStore,
} from './types';

export const getCurrentUserRequest = (payload?: SagaActionsProps) => {
    return {
        type: actionTypes.GET_CURRENT_USER_REQUEST,
        payload,
    } as const;
};

export const getCurrentUserSuccess = (payload: IUserProfileResponse) => {
    return {
        type: actionTypes.GET_CURRENT_USER_SUCCESS,
        payload,
    } as const;
};

export const getCurrentUserError = () => {
    return {
        type: actionTypes.GET_CURRENT_USER_ERROR,
    } as const;
};

export const updateUserEmail = (payload: BaseSendEmailRequest) => {
    return {
        type: actionTypes.UPDATE_USER_EMAIL,
        payload,
    } as const;
};

export const updateUserRequest = (payload: IUpdateUserRequest) => {
    return {
        type: actionTypes.UPDATE_USER_REQUEST,
        payload,
    } as const;
};

export const updateUserSuccess = (payload: IUserProfileResponse) => {
    return {
        type: actionTypes.UPDATE_USER_SUCCESS,
        payload,
    } as const;
};

export const updateUserError = (payload: UserStore['user_error']) => {
    return {
        type: actionTypes.UPDATE_USER_ERROR,
        payload,
    } as const;
};

export const resetUserData = () => {
    return {
        type: actionTypes.RESET_USER_DATA,
    } as const;
};

export const getUserFeatures = () => {
    return {
        type: actionTypes.GET_USER_FEATURES,
    } as const;
};

export const setUserFeatures = (payload: UserFeature[]) => {
    return {
        type: actionTypes.SET_USER_FEATURES,
        payload,
    } as const;
};

export const setUserAbTestPercentage = (payload: number) => {
    return {
        type: actionTypes.SET_USER_AB_TEST_PERCENTAGE,
        payload,
    } as const;
};

export const postGoogleAnalyticsId = () => {
    return {
        type: actionTypes.POST_GOOGLE_ANALYTICS_ID,
    } as const;
};

export const getUserPersonalisationRequest = () => {
    return {
        type: actionTypes.GET_USER_PERSONALISATION_REQUEST,
    } as const;
};

export const getUserPersonalisationSuccess = (payload: IUserPersonalisationData) => {
    return {
        type: actionTypes.GET_USER_PERSONALISATION_SUCCESS,
        payload,
    } as const;
};

export const getUserPersonalisationError = () => {
    return {
        type: actionTypes.GET_USER_PERSONALISATION_ERROR,
    } as const;
};

export const updateUserPersonalisationRequest = (payload: IUpdatePersonalisationRequest) => {
    return {
        type: actionTypes.UPDATE_USER_PERSONALISATION_REQUEST,
        payload,
    } as const;
};

export const updateUserPersonalisationSuccess = () => {
    return {
        type: actionTypes.UPDATE_USER_PERSONALISATION_SUCCESS,
    } as const;
};

export const updateUserPersonalisationError = () => {
    return {
        type: actionTypes.UPDATE_USER_PERSONALISATION_ERROR,
    } as const;
};

export const openSupportForm = (payload: { chatIsVisible: boolean }) => {
    return {
        type: actionTypes.OPEN_SUPPORT_FORM_REQUEST,
        payload,
    } as const;
};

export const openSupportFormSuccess = () => {
    return {
        type: actionTypes.OPEN_SUPPORT_FORM_SUCCESS,
    } as const;
};

export const getUserWebAnalyticsRequest = () => {
    return {
        type: actionTypes.GET_USER_WEB_ANALYTICS_REQUEST,
    } as const;
};

export const getUserWebAnalyticsSuccess = (payload: IUserWebAnalyticsResponse) => {
    return {
        type: actionTypes.GET_USER_WEB_ANALYTICS_SUCCESS,
        payload,
    } as const;
};

export const getUserWebAnalyticsError = () => {
    return {
        type: actionTypes.GET_USER_WEB_ANALYTICS_ERROR,
    } as const;
};
